import { IUser } from '~/models';
import { useAppSelector } from './useAppSelector';
import { useUserSelector } from './useUserSelector';

export const useSelectedOffice = (officeId?: string): IUser => {
  const user = useUserSelector();
  const childOffices = useAppSelector((state) => state.user.childOffices);

  return childOffices?.find((office) => office.id === officeId) ?? user;
};
